import { MifeParcel } from '@/components/MifeParcel';
import { SavingsPointsWidget } from '@/features/savings-points/components/savingsPointsWidget';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const SAVINGS_WIDGET_SLOT_ID = 'savings-points-widget-slot';

function Dashboard() {
  const [savingsWidgetSlot, setSavingsWidgetSlot] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const existingSlot = document.getElementById(SAVINGS_WIDGET_SLOT_ID);
    if (existingSlot) {
      setSavingsWidgetSlot(existingSlot);
      return;
    }

    const observer = new MutationObserver(() => {
      const slot = document.getElementById(SAVINGS_WIDGET_SLOT_ID);
      if (slot) {
        setSavingsWidgetSlot(slot);
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <MifeParcel />
      {savingsWidgetSlot && createPortal(<SavingsPointsWidget />, savingsWidgetSlot)}
    </>
  );
}

export const Route = createFileRoute('/_authenticated/dashboard')({
  component: Dashboard,
});
